<template>
  <b-card no-body>
    <b-card-body>
      <b-card bg-variant="light">
        <b-form-row @keyup.enter="load" class="mt-3">
          <lg-form-const-select @change="load" cols="2" sm="2" md="2" v-model="form.situacao"
            :options="form.optionsFilterSituacao" />
          <lg-form-input v-model="form.nome" description=" " cols="4" sm="4" md="4" />

          <b-col cols="2" style="margin-top: -9px;">
            <b-button id="localizarBanco" size="sm" style="height: 20px" pill variant="primary" @click="load">
              <div class="btn-size-alinhamento">
                <b-icon icon="search" /> &nbsp;
                <b-tooltip target="localizarBanco" title="Localizar"></b-tooltip>

              </div>
            </b-button>
          </b-col>


          <b-col cols="2" class="text-right" style="margin-top: -9px;">
            <b-button id="novoBancoAdd" class="" size="sm" style="height: 20px" pill variant="primary"
              @click="() => { this.showModalEdit = true }">
              <div class="btn-size-alinhamento">
                <b-icon scale="1" icon="plus" /> &nbsp;
              </div>
              <b-tooltip target="novoBancoAdd" title="Adicionar novo..."></b-tooltip>

            </b-button>
          </b-col>
        </b-form-row>
        <b-table responsive small :busy="this.busy" :items="this.records" :fields="this.tableFields" :hover="true"
          show-empty @row-dblclicked="bancoSelect">
          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </template>
          <template #empty>
            <p>Nenhum registro encontrado</p>
          </template>
          <template v-slot:cell(situacao)="row">
            <div :id="row.index + 'switchGrupo'">
              <b-form-checkbox v-model="row.item.situacao" @change="alteraSituacao(row.item)" name="check-button" switch
                size="lg" :value="1" :unchecked-value="0" />
              <b-tooltip :target="row.index + 'switchGrupo'" title="Ativar/Desativar..."></b-tooltip>
            </div>
          </template>
          <template v-slot:cell(editar)="{ item }">
            <b-button :id="'editar-' + item.id" class="my-2" size="sm" pill variant="primary"
              @click="abrirEditar(item)">
              <b-icon icon="pencil-square" />
              <b-tooltip :target="'editar-' + item.id" title="Editar..." triggers="hover"></b-tooltip>
            </b-button>
          </template>
        </b-table>
        <b-row style="margin-top: 12px" v-if="records && records.length > 0">
          <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
            Página {{ page }} de {{ totalPage }} - {{ total }} registros
          </b-col>
          <b-col cols="6">
            <div class="d-flex justify-content-end align-items-end">
              <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page" :per-page="perPage"
                :total-rows="total"></b-pagination>
            </div>
          </b-col>
        </b-row>
        <BancoForm v-if="showModalEdit" @close="cancelar" :isModal="true" :id="id" :prefix="prefix" />
      </b-card>
    </b-card-body>
  </b-card>
</template>

<script>
import ConfirmMixin from "@/core/mixins/confirm"

import ResourceService from "@/core/api/ResourceService";
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import { ListResourceMixin } from "@/core/mixins/resource";
import BancoForm from "./BancoForm.vue";

export default {
  components: {
    LgFormInput,
    LgFormConstSelect,
    BancoForm,
  },
  props: {
    onDblClickUnidadeFederativa: Function,
    prefix: {
      type: Array,
      default: () => ['Banco'],
    },
  },
  data() {
    return {
      emptyMessage: "",
      id: null,
      showModalEdit: false,
      form: {
        nome: "",
        situacao: 1,
        optionsFilterSituacao: [
          { key: "filterSituacao", text: "Todos", value: undefined },
          { key: "filterSituacao", text: "Ativo", value: 1 },
          { key: "filterSituacao", text: "Inativo", value: 0 },
        ],
      },
    };
  },
  mixins: [ListResourceMixin, ConfirmMixin],
  beforeMount() {
    this.$service = new ResourceService(`/api/banco`);
  },
  mounted() {
    this.load();
  },
  watch: {
    page() {
      this.load();
    },
  },
  computed: {
    updatedPrefix() {
      return [...this.prefix];
    },
    title() {
      return this.updatedPrefix.join(" > ");
    },
    actionsBtn() {
      return [
        {
          acao: () => {
            this.id = null;
            this.showModalEdit = true;
          },
          label: "Editar",
          icon: "pencil-square",
          type: "function",
        },
        {
          acao: this.$removeResource,
          label: "Deletar",
          icon: "trash",
          type: "function",
        },
      ];
    },
    tableFields() {
      return [
        { key: "compensacao", label: "Cód.Compensação" },
        { key: "sigla", label: "Sigla" },

        { key: "nome", label: "Nome" },
        { key: "situacao", label: " ", tdClass: "w-1" },
        { key: "editar", label: " ", tdClass: "w-1" },
      ];
    },
  },
  methods: {
    abrirEditar(item) {
      this.id = item.id;
      this.showModalEdit = true;
    },
    async bancoSelect(item) {
      this.$emit("onDblClickBanco", item);
    },
    async load() {
      this.busy = true;
      let filtro = {};
      if (this.form.nome) {
        filtro.nome = this.form.nome;
      }
      filtro.situacao = null;
      if (this.form.situacao != undefined) {
        filtro.situacao = this.form.situacao;
      }
      await this.$loadResource({
        limit: this.perPage,
        page: this.page,
        params: filtro,
      });

      this.busy = false;
    },
    async alteraSituacao(item) {
      let response = await this.$confirm(
        "Deseja " + (item.situacao === 1 ? "ativar" : "desativar") + " o Banco?",
        item.nome.toUpperCase()
      )
      if (response == true) {
        this.confirmarAlteracaoSituacao(item)
      } else {
        item.situacao = item.situacao === 1 ? 0 : 1
      }
    },


    async confirmarAlteracaoSituacao(item) {
      const { status } = await this.$service.alteraSituacao(item);
      if (status == 200) {
        this.$notify({
          type: "success",
          message: `Registro ${item.situacao ? "Ativado" : "Desativado"
            } com sucesso!`,
        })
      } else {
        this.$notify({
          type: "danger",
          message: `Erro ao ${item.situacao ? "Ativar" : "Desativar"
            } o registro!`,
        })
      }
    },

    cancelar() {
      this.showModalEdit = false;
      this.load();
    },
  },
};
</script>
